import { useContext } from 'react';
import type { AppThemingContextValue } from './Context';
import { AppThemingContext } from './Context';

/**
 * Custom hook to access AppThemingContext with type safety.
 * Throws an error if used outside of AppThemingContainer provider.
 *
 *
 * @example
 * ```tsx
 * const theming = useAppTheming();
 * const borderColor = theming.enabled
 *   ? theming.palette.primary.lighter
 *   : 'var(--pri-05, #76d1ff)';
 * ```
 */
export function useAppTheming(): AppThemingContextValue {
  const context = useContext(AppThemingContext);
  
  if (context === undefined) {
    throw new Error(
      'useAppTheming must be used within AppThemingContainer. ' +
      'Make sure your component is wrapped with <AppThemingContainer>.',
    );
  }
  
  // Type assertion to ensure TypeScript knows this is non-undefined
  return context;
}
